import React, { useState, useEffect } from 'react';
import ScheduleBuilder from './App';
import Privacy from './pages/Privacy';
import Support from './pages/Support';
import Marketing from './pages/Marketing';

export default function Router() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  if (path === '/privacy') return <Privacy />;
  if (path === '/support') return <Support />;
  if (path === '/marketing') return <Marketing />;
  return <ScheduleBuilder />;
}
